export function getInisial(str) {
	/*
		function for get initial from name or something
		by. ivan iddo - 25/04/2018
	*/

	var ret = ""; //initial return 
    var res = str.split(" "); //split string
    
    //get 1 character per word
    res.forEach(function(e){
    	ret = ret+e.substr(0,1);
    });
    
    return ret; //return result
}


// WEBPACK FOOTER //
// ./src/helpers/general-function.js